import { Date } from "isoly";
import "isoly/dist/CountryCode/Name/ar";
import { Category } from "./Category";
export var Transaction;
(function (Transaction) {
    function is(value) {
        return (value.category == undefined || Category.is(value.category)) &&
            typeof value.description == "string" &&
            typeof value.amount == "number" &&
            Date.is(value.date);
    }
    Transaction.is = is;
    function sum(transactions) {
        return transactions.reduce((r, t) => r + t.amount, 0);
    }
    Transaction.sum = sum;
    function fromCsv(csv, divider = ",", headerMap = { Text: "description", Belopp: "amount", Datum: "date" }) {
        let result;
        let splitted = csv.split(/\r?\n/g);
        let headers = splitted[0].split(divider);
        result = splitted.splice(1).map((row, index) => {
            let values = row.split(divider).map(v => v.trim());
            let transaction = values.reduce((r, c, i) => {
                let property = headerMap[headers[i]];
                let value = property == undefined
                    ? undefined
                    : property == "description" || property == "date"
                        ? c
                        : getAmountFromString(c);
                return property ? Object.assign(Object.assign({}, r), { [property]: value }) : r;
            }, {});
            return transaction;
        }).filter(t => Transaction.is(t));
        return result;
    }
    Transaction.fromCsv = fromCsv;
    function getAmountFromString(value) {
        return value == ""
            ? 0
            : (/^\-?\d+(\.\d+)?(kr)?$/g.test(value.replace(",", ".").replace(/ /g, "").replace("\r", ""))
                ? +value.substring(0, value.length - 4).replace(",", ".").replace(/ /g, "").replace("\r", "")
                : undefined);
    }
    // function csvToObject(csv: string, divider=","): Record<string, any>[] {
    //   let result = []
    //   let splitted = csv.split("\n")
    //   headers = splitted[0].split(divider).map(h => h.replace("\r", ""))
    //   splitted.splice(1).forEach((row, index) => {
    //     let values = row.split(divider)
    //     result.push(values.reduce((r, c, i) => ({...r, [headers[i]]: convert(c.trim())}), {}))
    //   })
    //   headerTypes = headers.reduce((r: Record<string, "string" | "number">, h: string) => {
    //     let typ = typeof result[0][h]
    //     return typ == "string" || typ == "number" ? {...r, [h]: typ} : r
    //   }, ({} as Record<string, "string" | "number">))
    //   return result
    // }
})(Transaction || (Transaction = {}));
